import { z } from 'zod';
import { LeadLifecycleStatus } from '@/models/entities/lead.ts';
import {
  ContactabilityFilterEnum,
  UrgencyFilterEnum,
} from '@/models/ui/filterChip.ts';
import type { LeadStatusGroup } from '@/models/ui/leadStatusGroup.ts';
import { SearchQueryBrand, SearchQueryNone } from '@/models/ui/search.ts';

export const LeadFiltersSchema = z.object({
  statusGroup: z.custom<LeadStatusGroup>().optional(),
  statuses: z.array(z.enum(LeadLifecycleStatus)).default([]),
  urgencies: z.array(UrgencyFilterEnum).default([]),
  contactabilities: z.array(ContactabilityFilterEnum).default([]),
  search: SearchQueryBrand.default(SearchQueryNone),
});

export type LeadFilters = z.infer<typeof LeadFiltersSchema>;
